// Basic
const trapFocusHandlers = {};
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus();
}
function trapFocus(container, elementToFocus = container) {
  const focusableEls = Array.from(
      container.querySelectorAll(
        'summary, a[href], area[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe, audio[controls], video[controls], [tabindex]:not([tabindex^="-"])',
      ),
    ),
    firstEl = focusableEls[0],
    lastEl = focusableEls[focusableEls.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (evt) => {
      (evt.target !== container &&
        evt.target !== lastEl &&
        evt.target !== firstEl) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = () => {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = (evt) => {
      evt.code === "Tab" &&
        (evt.target === lastEl &&
          !evt.shiftKey &&
          (evt.preventDefault(), firstEl.focus()),
        (evt.target === container || evt.target === firstEl) &&
          evt.shiftKey &&
          (evt.preventDefault(), lastEl.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    (elementToFocus || container).focus();
};
class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector(".js-overlay");
    this.productInfo = document.querySelector(".product-info");
  }
  handleClick(evt) {
    console.log(evt.target);
    (evt.target.matches(".js-close-drawer") || evt.target === this.overlay) &&
      this.close();
  }
  open(opener, elementToFocus, callback) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-open`, { bubbles: !0 }),
    ),
      (this.scrollY = window.scrollY),
      // document.body.classList.add("fixed"),
      // (document.body.style.top = `-${this.scrollY}px`),
      (document.documentElement.style.height = "100svh"),
      this.overlay.classList.add("is-visible"),
      this.productInfo.classList.add("product-info--relative"),
      this.setAttribute("open", ""),
      this.setAttribute("aria-hidden", "false"),
      (this.opener = opener),
      trapFocus(this, elementToFocus),
      (this.clickHandler = this.clickHandler || this.handleClick.bind(this)),
      (this.keyupHandler = (evt) => {
        evt.key !== "Escape" ||
          evt.target.closest(".cart-drawer-popup") ||
          this.close();
      }),
      this.addEventListener("click", this.clickHandler),
      this.addEventListener("keyup", this.keyupHandler),
      this.overlay.addEventListener("click", this.clickHandler);
    const transitionDuration = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms"),
    );
    setTimeout(() => {
      callback && callback(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-open`, {
            bubbles: !0,
          }),
        );
    }, transitionDuration);
  }
  close(callback) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-close`, { bubbles: !0 }),
    ),
      this.removeAttribute("open"),
      this.setAttribute("aria-hidden", "true"),
      this.overlay.classList.remove("is-visible"),
      this.productInfo.classList.remove("product-info--relative"),
      removeTrapFocus(this.opener),
      (document.documentElement.style.height = ""),
      (document.body.style.top = ""),
      // document.body.classList.remove("fixed"),
      // window.scrollTo(0, this.scrollY),
      this.removeEventListener("click", this.clickHandler),
      this.removeEventListener("keyup", this.keyupHandler),
      this.overlay.removeEventListener("click", this.clickHandler);
    const transitionDuration = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms"),
    );
    setTimeout(() => {
      callback && callback(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-close`, {
            bubbles: !0,
          }),
        );
    }, transitionDuration);
  }
};
customElements.define("side-drawer", SideDrawer);

// 
if (!customElements.get("accessories-bundle")) {
  class AccessoriesBundle extends HTMLElement {
    constructor() {
      super(), this.initialize();
    }
    initialize() {
      this.attachEventListeners([
        {
          selector: ".variant-selector",
          event: "change",
          handler: this.handleVariantChange.bind(this),
        },
        {
          selector: ".update-accessory",
          event: "click",
          handler: this.handleClickUpdateBtn.bind(this),
        },
        {
          selector: ".add-accessory",
          event: "click",
          handler: this.handleClickUpdateBtn.bind(this),
        },
        {
          selector: ".return-btn",
          event: "click",
          handler: AccessoriesBundle.handleCancelBtnClick,
        },
        {
          selector: ".js-close-drawer",
          event: "click",
          handler: AccessoriesBundle.handleCancelBtnClick,
        }
      ]);
    }
    attachEventListeners(events) {
      events.forEach(({ selector, event, handler }) => {
        this.querySelectorAll(selector).forEach((element) => {
          element.addEventListener(event, handler);
        });
      });
    }
    handleVariantChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex],
        listItem = event.target.closest("li");
      if (!listItem || !selectedOption) return;
      const variantId = selectedOption.value,
        imageUrl = selectedOption.getAttribute("data-image"),
        price = selectedOption.getAttribute("data-price");
      listItem.querySelectorAll(".variant-selector").forEach((selector) => {
        selector.value = variantId;
      });
      const accessoryImg = listItem.querySelector(".accessory-img");
      accessoryImg && (accessoryImg.src = imageUrl),
        listItem.setAttribute("data-variantid", variantId),
        listItem.querySelectorAll(".price__current").forEach((priceElement) => {
          priceElement.textContent = price;
        });
    }
    handleClickUpdateBtn(event) {
      const listItem = event.target.closest("li");
      if (!listItem) return;
      const checkbox = listItem.querySelector(".accessory-checkbox");
      checkbox &&
        ((checkbox.checked = !0),
        checkbox.setAttribute("aria-checked", "true")),
        AccessoriesBundle.handleCancelBtnClick(event);
    }
    static handleCancelBtnClick(event) {
      const sideDrawer = event.target.closest("side-drawer");
      sideDrawer && sideDrawer.close();
    }
  }
  customElements.define("accessories-bundle", AccessoriesBundle);
}